import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PlagiarismOutlinedIcon from "@mui/icons-material/PlagiarismOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import {
  Divider,
  IconButton,
  Link,
  ListItem,
  Typography,
  keyframes,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Text from "@mui/material/Typography";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getRemoteLogUserDetails } from "../../api/Auth/RemoteLog.api";
import { checkMultipleArticleExistence } from "../../api/MyLibrary/MyFolders.api";
import { getAlertSettings } from "../../api/MyLibrary/TOCAlerts.api";
import { useGetMySearchPreference } from "../../api/Preferences/Subjects.api";
import {
  useGetAutoComplete,
  useSpellCorrection,
} from "../../api/Search/Autocomplete.api";
import {
  authorJsonFacetQuery,
  basicSearchForCounts,
  basicSearchMain,
  basicSearchQuery,
  dSpaceSearchQuery,
  fetchMeshKeywordsData,
  jsonFacetQuery,
  meshKeywordJsonFacetQuery,
  subjectJsonFacetQuery,
} from "../../api/Search/BasicSearch.api";
import { getOpacData } from "../../api/Search/CollectionApi";
import api from "../../api/endpoints";
import { formatString, queryConstructor } from "../../api/formQuery";
import { getBulkLinkRecords } from "../../api/linkResolverApi";
import { usagelogApi } from "../../api/usageReportApi";
import bookImage from "../../assets/images/book-bookmark.svg";
import SearchCircle from "../../assets/img/search-builder.png";
import { Switch } from "../../components/Switch";
import { ThemeContext } from "../../contexts";
import useClickOutsideListner from "../../hooks/ClickOutsideListner.hook";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  resetAppliedQueries,
  updateQueries,
} from "../../store/slice/appliedQueries";
import { updateIsAuthorResult } from "../../store/slice/authorFinderSlice";
import {
  clearAllFilters as clearAllJournalFilters,
  updatecollection,
  updateSortName,
  updateSort as updateJournalSort,
  updateBrowserRow,
  updateBrowserPage,
  updateBookCollection,
} from "../../store/slice/browseFilterSlice";
import {
  getContainOrStartingWIth,
  setSearchKeyword,
  updateBrowseJournalSearch,
} from "../../store/slice/browseJournal";
import { updateCaptchaStatus } from "../../store/slice/captchaVerification";
import {
  clearAllFilters,
  clearAllFiltersValue,
  clearLimits,
  clearPublicationFilter,
  clearSearchedAuthor,
  clearSJRandABDCFilters,
  updataLibraryOpac,
  updateAllFilter,
  updateAuthor,
  updateCountryOfPublishingAuthor,
  updateDSPACECollection,
  updateInstitution,
  updateIsOpac_dspace,
  updateJournal,
  updatePublisher,
  updateSort,
  updateYearFrom,
} from "../../store/slice/filterSlice";
import { setModal } from "../../store/slice/modalSlice";
import { updateQuery } from "../../store/slice/queryForCountSlice";
import { enterAIMode, exitAIMode } from "../../store/slice/aiModeSlice";
import {
  clearDataTypeFilters,
  clearJosnFacets,
  clearMeshKeyword,
  clearSearchTerm,
  clearSubstances,
  updateAlertSettingData,
  updateAll,
  updateAllFacets,
  updateAuthorFacets,
  updateAuthorFiltersLoader,
  updateDSpace,
  updateDataType,
  updateFullText,
  updateIsNavigatingBack,
  updateLinkToDisplay,
  updateMarkedArticleCount,
  updateMeshKEywordFacets,
  updateMeshKeywordFacetsList,
  updateOpacResults,
  updateOtherFiltersLoader,
  updatePage,
  updateRow,
  updateSavedArticles,
  updateSearchResults,
  updateSearchTerm,
  updateSearchType,
  updateSubjectFacets,
  updateSubjectFilterLoader,
  updateSubjectL1Type,
  updateSubjectName,
  updateSubjectType,
  clearClassificationNum,
} from "../../store/slice/searchSlice";
import { clearAllSetSearch } from "../../store/slice/setSearch";
import {
  GetCustomerByIDDatatype,
  GetCustomerByIDSubject,
} from "../../types/GetCustomerByID.types";
import { GetMyPreferenceData } from "../../types/GetMySubjects.types";
import { SaverArticlesType } from "../../types/interface";
import { notify } from "../../utils/Notify";
import { dataTypes } from "../../utils/constants";
import {
  isPreferenceAdded,
  showIsProfileToast,
  sortTags,
} from "../../utils/helper";
import { validateSearchTerm } from "../../utils/validateSearchTerm";
import { temporaryQueryConstructor } from "../AdvancedSearch/TemporaryQueryConstructor";
import AutoCompleteField from "../Search/AutoCompleteField";
import { updatedStoredSelectedIssue } from "../../store/slice/browserFilterSliceDetails";
import { getContainOrStartingWIth as getContainOrStartingWIthforPublisher } from "../../store/slice/browserPublisher";
import { getContainOrStartingWIth as getContainOrStartingWIthForPackage } from "../../store/slice/browsePackage";
import { updateBookPublisherCollection } from "../../store/slice/browserFilterSlicePublisher";
import HeaderSection from "../Search/HeaderSection";

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);

interface SearchInput {
  searchterm: string;
}

interface Notification {
  id: number;
  datefrom: string;
  dateto: string;
  notificationmessage: string;
  isactiveflag: boolean;
  createddate: string;
  createdby: string;
  modifieddate: string;
  modifiedby: string;
  url: string;
}

type SearchMode = "boolean" | "semantic";

const AISearch = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const themeContext = useContext(ThemeContext);
  const { handleSubmit, control, setValue, watch, setError, clearErrors } =
    useForm<SearchInput>();
  const location = useLocation();

  const isNavigatingBack = useAppSelector(
    (state) => state.searchReducer.isNavigatingBack,
  );
  const selector = useAppSelector((state) => state.login);
  const searchHistoryData = useAppSelector(
    (state) => state.searchHistory.handleHistory,
  );

  const searchReducer = useAppSelector((state) => state.searchReducer);
  const l1SubjectIds = useAppSelector(
    (state) => state.searchReducer.subjectL1Type,
  );

  const defaultSubjectIds = useAppSelector(
    (state) => state.searchReducer?.defaultSubjectType,
  );

  const enable_onos = useAppSelector(
    (state: any) => state.customer?.customerDetails?.is_enable_onos,
  );

  const {
    ref,
    showList: showAutoComplete,
    setShowList: setShowAutoComplete,
  } = useClickOutsideListner(false);

  const isPreferenceEnabled = sessionStorage.getItem("preference") === "true";

  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [autoCompleteData, setAutoCompleteData] = useState<string[] | null>(
    null,
  );
  const [isPreference, setIsPreference] = useState(isPreferenceEnabled);
  const [allTags, setAllTags] = useState<GetCustomerByIDDatatype[]>([]);
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [subjectData, setSubjectData] = useState<GetCustomerByIDSubject[]>([]);
  const [selectedSubjects, setSelectedSubjects] = useState<number[]>([0]);
  const [selectedSubjectNames, setSelectedSubjectNames] = useState<string[]>(
    [],
  );
  const [isAllSubjectSelected, updateSubjectSelected] = useState(false);
  const [showIpLoginModal, setIpLoginModal] = useState(false);

  // Search mode: boolean (current flow) or semantic (AI-powered)
  const [searchMode, setSearchMode] = useState<SearchMode>("semantic");
  const isSemanticMode = searchMode === "semantic";

  // Stores the user's natural-language query (for breadcrumbs)
  const [aiUserQuery, setAiUserQuery] = useState("");

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  // Banner state
  const [isBanner, setIsBanner] = useState(false);

  // Welcome modal state
  const [modalIsOpen, setModalIsOpen] = useState(false);

  // Notification expiry state (replaces HeaderSection logic)
  const [isExpired, setIsExpired] = useState(false);

  const customerData = useAppSelector(
    (state) => state.customer.customerDetails,
  );
  const profileData = useAppSelector((state) => state.login);

  const profileData1 = useAppSelector(
    (state) => state.customer.customerDetails,
  );
  const customerDataTypes: any = profileData1?.datatypes?.map((item: any) => {
    return item?.dat_resourcetype_id;
  });
  const onlyJournals =
    customerDataTypes?.length === 4 &&
    customerDataTypes.includes(1 && 2 && 5 && 24);

  const isAICustomer =
    customerData?.informaticscustomer_id === 18 ||
    profileData?.informaticscustomer_id === "18";

  const { data: myPreference, refetch } = useGetMySearchPreference(
    selector.user_id,
    isPreference,
  );
  const [isProfileUser, setIsProfileUser] = useState(false);
  const [ipAddress, setIpAddress] = useState<string>("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchBoxSearchTerm = urlParams.get("q") || "";
  const [dropdown, setDropDown] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const hasrefetchRef = useRef(false);

  const [activeScreenWidth, setActiveScreenWidth] = useState<number>(5);

  const is_xs = useMediaQuery("(max-width: 299px)");
  const isxs = useMediaQuery("(min-width: 299px) and (max-width: 600px)");
  const isSm = useMediaQuery("(min-width: 600px) and (max-width: 899px)");
  const isMd = useMediaQuery("(min-width: 900px) and (max-width: 1199px)");
  const islg = useMediaQuery("(min-width: 1200px) and (max-width: 1535px)");
  const isXl = useMediaQuery("(min-width: 1536px)");

  // Notification content derived from fetched data (mirrors HeaderSection logic)
  const IST = "Asia/Kolkata";
  const expiryDateTime = notifications?.[0]?.dateto || "31-05-2025 11:00";
  const notificationMessage = notifications?.[0]?.notificationmessage ?? "";
  const sentences = notificationMessage
    .split(".")
    .map((word: string) => word.trim())
    .filter(Boolean);
  const [headlinePart, datePart] = sentences[0]?.split(",") ?? [];
  const notifPart1 = headlinePart ? `${headlinePart},` : "";
  const notifPart2 = datePart?.trim() ?? "";
  const notifPart3 = sentences.slice(1).join(". ");

  const notificationAnimation = keyframes`
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  `;

  const scrollRightToLeft = keyframes`
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  `;

  const logSearchUsageData = async (usageActionID: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_id
        ? informaticscustomer_id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const ip_4_Address = ipAddress ? ipAddress : null;
    await usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      null,
      null,
      null,
      null,
      null,
      null,
      ip_4_Address,
      null,
      sessionKey,
      1,
      null,
      0,
    );
  };

  const bookUser = useSelector(
    (state: any) => state?.customer?.customerDetails?.datatypes,
  )?.map((item: any) => {
    return item?.dat_resourcetype_id;
  });

  useEffect(() => {
    if (api.baseApi !== "https://diskoverapi.jgatenext.com") {
      setIsBanner(true);
    } else {
      setIsBanner(false);
    }
  }, [isBanner]);

  useEffect(() => {
    const fetchNotificationInfo = async () => {
      try {
        const response = await fetch(
          `${api.baseApi}/api/get_active_flashnotifications/`,
        );
        const data = await response.json();
        setNotifications(data?.data?.[0][0] ?? []);
      } catch (error) {
        console.log("Error fetching flash notification:", error);
      }
    };
    fetchNotificationInfo();
  }, []);

  // Notification expiry effect (mirrors HeaderSection logic)
  useEffect(() => {
    if (!expiryDateTime) return;
    const targetTime = dayjs.tz(expiryDateTime, "DD-MM-YYYY HH:mm", IST);
    const checkTimeAndRefresh = () => {
      const nowIST = dayjs().tz(IST);
      setIsExpired(nowIST.isSameOrAfter(targetTime));
    };
    checkTimeAndRefresh();
    window.addEventListener("focus", checkTimeAndRefresh);
    document.addEventListener("visibilitychange", checkTimeAndRefresh);
    const interval = setInterval(checkTimeAndRefresh, 10000);
    return () => {
      window.removeEventListener("focus", checkTimeAndRefresh);
      document.removeEventListener("visibilitychange", checkTimeAndRefresh);
      clearInterval(interval);
    };
  }, [expiryDateTime]);

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch(
          "https://diskoverapi.jgatenext.com/api/get_client_ip/",
        );
        const data = await response.json();
        setIpAddress(data?.client_ip);
      } catch (error) {
        setIpAddress("0");
        console.log("Error fetching IP address:", error);
      }
    };
    fetchIpAddress();
  }, []);

  useEffect(() => {
    if (is_xs) {
      setActiveScreenWidth(0);
    } else if (isxs) {
      setActiveScreenWidth(1);
    } else if (isSm) {
      setActiveScreenWidth(2);
    } else if (isMd) {
      setActiveScreenWidth(3);
    } else {
      setActiveScreenWidth(5);
    }
  }, [is_xs, isxs, isSm, isMd]);

  useEffect(() => {
    dispatch(clearAllFilters());
    dispatch(clearSearchedAuthor());
    dispatch(updateMarkedArticleCount([]));
    dispatch(clearAllFiltersValue());
    dispatch(resetAppliedQueries());
    dispatch(clearPublicationFilter());
    dispatch(clearAllSetSearch());
    dispatch(updateSearchType("1"));
    dispatch(updateIsAuthorResult(false));
    dispatch(updateBrowseJournalSearch(false));
    dispatch(clearLimits());
    dispatch(clearAllJournalFilters());
    dispatch(updatedStoredSelectedIssue(false));
    dispatch(clearSJRandABDCFilters());
    dispatch(updatecollection(""));
    sessionStorage.removeItem("isGuestUserLogin");
    dispatch(updateJournalSort("resource_name_tk asc"));
    // dispatch(updateSortName("Journal"));
    dispatch(updateSortName("Title"));
    dispatch(setSearchKeyword([]));
    dispatch(getContainOrStartingWIth("Starting With"));
    dispatch(getContainOrStartingWIthforPublisher("Starting With"));
    dispatch(getContainOrStartingWIthForPackage("Starting With"));
  }, []);

  useEffect(() => {
    if (!hasrefetchRef.current) {
      sessionStorage.getItem("isProfileUser") === "true" && refetch();
      hasrefetchRef.current = true;
    }
  }, [sessionStorage.getItem("isProfileUser")]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const userId = sessionStorage.getItem("isProfileUser");
      if (userId === "true") {
        setIsProfileUser(true);
      } else if (userId === "false") {
        setIsProfileUser(false);
      }
    }, 500);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    try {
      if (customerData) {
        let filteredSubjectData: GetCustomerByIDSubject[] = [];
        let filteredSubjectIds: number[] = [];
        let filteredSubjectNames: string[] = [];
        let filteredAllTags: GetCustomerByIDDatatype[] = [];
        let filteredSelectedTags: number[] = [];
        let isAllSelected: boolean = true;
        let filteredSubjectl1Ids: number[] = [];
        const selectedDocTypes =
          Array.isArray(searchReducer.dataType) &&
          searchReducer.dataType?.filter((x) => x !== 2);

        const selectedSubjectsFromStore =
          Array.isArray(searchReducer.subjectType) && searchReducer.subjectType;
        let allDocIds: any = customerData?.datatypes
          .filter((x) => x.dat_resourcetype_id !== 2)
          ?.map((obj) => obj?.dat_resourcetype_id);

        if (isPreference && myPreference) {
          filteredSubjectData =
            myPreference.Subjects?.map(({ subject_id1, subject2_details }) =>
              subject2_details
                .filter(({ is_favorite }) => is_favorite)
                .map((l2) => ({
                  datsubjectmasterlevel1_id: subject_id1,
                  datsubjectmasterlevel2_id: l2.subject_id2,
                  level2subject_name: l2.subject_name2,
                })),
            ).flat() || [];

          filteredSubjectIds = filteredSubjectData?.map(
            ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
          );
          filteredSubjectNames = filteredSubjectData?.map(
            ({ level2subject_name }) => level2subject_name,
          );
          filteredSubjectl1Ids = filteredSubjectData.map(
            ({ datsubjectmasterlevel1_id }) => datsubjectmasterlevel1_id,
          );

          filteredSelectedTags = myPreference?.DataTypes.filter(
            ({ is_favorite }) => is_favorite,
          )?.map(({ datatype_id }) => datatype_id);

          filteredAllTags = customerData?.datatypes?.filter(
            (x) => x.dat_resourcetype_id !== 2,
          );
          filteredAllTags = filteredAllTags?.filter(
            (x) => x.dat_resourcetype_id !== 24,
          );
          filteredAllTags = filteredAllTags.filter(
            (x) => x.dat_resourcetype_id !== 5,
          );

          isAllSelected =
            filteredSelectedTags.length === myPreference?.DataTypes.length;
        } else {
          filteredSubjectData = customerData.subject;
          filteredSubjectIds = Array.isArray(filteredSubjectData)
            ? filteredSubjectData?.map(
                ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
              )
            : [];
          filteredSubjectl1Ids = filteredSubjectData.map(
            ({ datsubjectmasterlevel1_id }) => datsubjectmasterlevel1_id,
          );
          filteredSubjectNames = Array.isArray(filteredSubjectData)
            ? filteredSubjectData?.map(
                ({ level2subject_name }) => level2subject_name,
              )
            : [];

          filteredAllTags = customerData?.datatypes?.filter(
            (x) => x.dat_resourcetype_id !== 2,
          );
          filteredAllTags = filteredAllTags?.filter(
            (x) => x.dat_resourcetype_id !== 24,
          );
          filteredAllTags = filteredAllTags.filter(
            (x) => x.dat_resourcetype_id !== 5,
          );
        }

        setSubjectData(() => filteredSubjectData);

        let docArray: any = [];
        let libraryCatalogue = customerData?.other_integreted_product?.map(
          (val) => val.other_product_type,
        );
        const lib_koha = libraryCatalogue?.includes("Koha");
        const lib_dspace = libraryCatalogue?.includes("DSpace Integration");
        if (filteredAllTags) {
          if (lib_koha && lib_dspace) {
            docArray = [
              ...filteredAllTags,
              {
                dat_resourcetype_id: 100,
                accesstype: "Library Catalogue",
                image_small: "library_catalogue",
              },
              {
                dat_resourcetype_id: 101,
                accesstype: "IR/DSPACE",
                image_small: "dspace_integration",
              },
            ];
            if (!onlyJournals) {
              docArray.unshift({
                dat_resourcetype_id: 0,
                accesstype: "All",
                image_small: "all",
              });
            }
          } else if (lib_koha) {
            docArray = [
              ...filteredAllTags,
              {
                dat_resourcetype_id: 100,
                accesstype: "Library Catalogue",
                image_small: "library_catalogue",
              },
            ];
            if (!onlyJournals) {
              docArray.unshift({
                dat_resourcetype_id: 0,
                accesstype: "All",
                image_small: "all",
              });
            }
          } else if (lib_dspace) {
            docArray = [
              ...filteredAllTags,
              {
                dat_resourcetype_id: 101,
                accesstype: "IR/DSPACE",
                image_small: "dspace_integration",
              },
            ];
            if (!onlyJournals) {
              docArray.unshift({
                dat_resourcetype_id: 0,
                accesstype: "All",
                image_small: "all",
              });
            }
          } else {
            docArray = [...filteredAllTags];
            if (!onlyJournals) {
              docArray.unshift({
                dat_resourcetype_id: 0,
                accesstype: "All",
                image_small: "all",
              });
            }
          }
        }

        let selectedDoc = isAllSelected
          ? docArray?.map((x: any) => x?.dat_resourcetype_id)
          : filteredSelectedTags;

        if (selectedTags.length && !isPreference) {
          setSelectedTags([...new Set([...(allDocIds || []), 0, 100, 101])]);
        } else if (
          selectedDocTypes &&
          selectedDocTypes.length &&
          !isPreference
        ) {
          setSelectedTags(selectedDocTypes);
          if (
            window.location.pathname === "/initialSearch" &&
            !isNavigatingBack
          ) {
            setSelectedTags(selectedDoc);
          }
        } else {
          setSelectedTags(selectedDoc);
        }

        if (
          selectedSubjectsFromStore &&
          selectedSubjectsFromStore.length &&
          !isPreference
        ) {
          setSelectedSubjects(() => selectedSubjectsFromStore);
          let subNames: string[] = [];
          for (let id of selectedSubjectsFromStore) {
            for (let obj of customerData?.subject) {
              if (id === obj?.datsubjectmasterlevel2_id) {
                subNames.push(obj?.level2subject_name);
              }
            }
          }
          dispatch(updateSubjectName(subNames));
          setSelectedSubjectNames(() => subNames);
        } else {
          setSelectedSubjects(() => filteredSubjectIds);
          dispatch(updateSubjectName(filteredSubjectNames));
          setSelectedSubjectNames(() => filteredSubjectNames);
        }

        setAllTags(() => docArray);
      }
    } catch (err) {
      console.log("Unknown error occurred", err);
    }
  }, [customerData, dispatch, isPreference, myPreference]);

  // In AI (semantic) mode we skip autocomplete + spell-check entirely
  // by passing an empty query, which disables the underlying React-Query hooks.
  const { data: autoComplete } = useGetAutoComplete(
    isSemanticMode ? "" : searchValue,
  );

  const { spellCorrectionQuery, wrongWord, suggestionsData } =
    useSpellCorrection(
      isSemanticMode ? "" : searchValue,
      !isSemanticMode && !autoCompleteData?.length,
    );

  useEffect(() => {
    const subscription = watch(({ searchterm }: string | any) => {
      if (searchterm) {
        clearErrors("searchterm");
        setSearchValue(searchterm?.toLocaleLowerCase());
        searchterm.length >= 3
          ? setShowAutoComplete(true)
          : setShowAutoComplete(false);
      }
    });
    return () => subscription.unsubscribe();
  }, [setShowAutoComplete, watch]);

  useEffect(() => {
    updateAllSubject();
  }, [selectedSubjects.length, customerData?.subject?.length]);

  useEffect(() => {
    selectAllTags();
  }, [selectedTags.length]);

  useEffect(() => {
    if (autoComplete) {
      const arr = autoComplete?.map((x) => Object.keys(x)[0]);
      setAutoCompleteData(() => arr);
    }
  }, [autoComplete]);

  const handleSubjectName = (arr: number[]) => {
    let names: string[] = [];
    subjectData.forEach((item) => {
      if (arr.includes(item.datsubjectmasterlevel2_id))
        names.push(item.level2subject_name);
    });
    setSelectedSubjectNames(() => names);
  };

  const handleSubjectDropdown = (data: GetCustomerByIDSubject) => {
    logSearchUsageData(9);
    if (selectedSubjects.includes(data.datsubjectmasterlevel2_id)) {
      const newArr = selectedSubjects.filter(
        (x) => x !== data.datsubjectmasterlevel2_id,
      );
      const l1subIds = l1SubjectIds.filter(
        (x) => x !== data.datsubjectmasterlevel1_id,
      );
      dispatch(updateSubjectL1Type(l1subIds));
      handleSubjectName(newArr);
      setSelectedSubjects(() => newArr);
    } else {
      const newArr = [...selectedSubjects, data.datsubjectmasterlevel2_id];
      const newArr1 = [...l1SubjectIds, data.datsubjectmasterlevel1_id];
      dispatch(updateSubjectL1Type(newArr1));
      handleSubjectName(newArr);
      setSelectedSubjects(() => newArr);
    }
  };

  const handleTags = (id: number) => {
    if (onlyJournals) return;
    logSearchUsageData(10);
    sessionStorage.setItem("preference", "false");
    setIsPreference(false);
    const allDocIds: any = customerData?.datatypes
      .filter((x) => x.dat_resourcetype_id !== 2)
      ?.map((obj) => obj?.dat_resourcetype_id);
    if (id === 0) {
      sessionStorage.setItem("preference", "false");
      setIsPreference(false);
      dispatch(clearDataTypeFilters());
      if (
        selectedTags.length === allDocIds?.length + 3 ||
        selectedTags.length === allDocIds?.length + 2 ||
        selectedTags.length === allDocIds?.length + 1
      ) {
        setSelectedTags([]);
      } else {
        setSelectedTags([...allDocIds, 0, 100, 101]);
      }
    } else {
      if (selectedTags.includes(0)) {
        // In ALL mode — switch to only this type
        setSelectedTags([id]);
      } else if (selectedTags.includes(id)) {
        setSelectedTags(selectedTags.filter((item) => item !== id));
      } else {
        setSelectedTags([...selectedTags, id]);
      }
    }
  };

  function selectAllTags() {
    // No-op: ALL mode is only triggered by explicitly clicking the ALL chip.
  }

  async function handleSearch({ searchterm }: SearchInput) {
    if (loading) return;
    dispatch(exitAIMode());
    dispatch(clearSearchTerm());
    dispatch(clearMeshKeyword());
    dispatch(clearSubstances());
    dispatch(clearAllFiltersValue());
    dispatch(clearClassificationNum());
    if (Array.isArray(selectedSubjects) && selectedSubjects.length === 0) {
      setError("searchterm", {
        type: "custom",
        message: "Minimum one Subject should be selected to perform search",
      });
      return;
    }

    if (Array.isArray(selectedTags) && selectedTags.length === 0) {
      setError("searchterm", {
        type: "custom",
        message:
          "Minimum one Document type should be selected to perform search",
      });
      return;
    }

    if (!searchterm.trim()) {
      setError("searchterm", {
        type: "required",
        message: "Please input valid keyword / topic to search",
      });
      return;
    }

    if (!validateSearchTerm(searchterm)) {
      setError("searchterm", {
        type: "required",
        message: "Please input valid keyword / topic to search",
      });
      return;
    }

    setLoading(true);

    const searchedData = {
      key: "search-term",
      value: searchterm.trim(),
    };

    dispatch(updateAllFilter(searchedData));
    dispatch(updateSearchTerm(searchterm.trim()));
    dispatch(updateSubjectType(selectedSubjects));
    dispatch(updateSubjectName(selectedSubjectNames));
    dispatch(updateRow(15));
    dispatch(updatePage(1));
    dispatch(updateSort("dateofpublication desc"));
    dispatch(
      updateQueries({
        key: "searchTerm",
        value: searchterm.trim(),
      }),
    );

    dispatch(updateSubjectFacets([]));
    dispatch(updateAuthorFacets([]));
    dispatch(updateAllFacets([]));

    let encodedSubjects = "";
    if (selectedSubjects.length === 0) {
      encodedSubjects = `(${temporaryQueryConstructor(
        subjectData?.map((x) => x.datsubjectmasterlevel2_id),
      )})`;
    } else {
      encodedSubjects = `(${temporaryQueryConstructor(selectedSubjects)})`;
    }

    let encodedTags = "";
    let tags = [...selectedTags];
    if (tags.includes(1) && !tags.includes(2)) tags.push(2);
    if (tags.includes(1) && !tags.includes(5)) tags.push(5);
    if (tags.includes(1) && !tags.includes(24)) tags.push(24);
    if (!tags.includes(1) && tags.includes(2))
      tags = tags.filter((tag) => tag !== 2);
    if (!tags.includes(1) && tags.includes(5))
      tags = tags.filter((tag) => tag !== 5);
    if (!tags.includes(1) && tags.includes(24))
      tags = tags.filter((tag) => tag !== 24);

    dispatch(updateDataType(tags));

    const removeIds = [0, 100, 101];

    if (tags.length === 0) {
      encodedTags = "( 1 OR 4 OR 2 OR 3 OR 8 OR 24 )";
    } else if (tags.length === 2 && tags.includes(100) && tags.includes(101)) {
      encodedTags = "(100 OR 101)";
    } else if (tags.length === 1 && (tags[0] === 100 || tags[0] === 101)) {
      encodedTags = `(${tags[0]})`;
    } else {
      encodedTags = `(${temporaryQueryConstructor(tags)})`;
    }

    const queryObj: any = {
      titleKeywordsAbs: searchterm.trim(),
      sort: "dateofpublication desc",
      fq__resource_type: encodedTags,
      rows: 15,
      op_mode: "and",
      sessionid: sessionStorage.getItem("session_key"),
      profileuserid: sessionStorage.getItem("user_id"),
      datsearchtype_id: "1",
      customerid: sessionStorage.getItem("informaticscustomer_id"),
    };

    if (
      encodedSubjects &&
      selectedSubjects.length &&
      !selectedSubjects.includes(0)
    ) {
      if (enable_onos && selectedSubjects.length === defaultSubjectIds.length) {
        Object.assign(queryObj, {
          "fq__(subjects_id_l2": `${encodedSubjects} OR is_onos_resource=true)`,
        });
      } else {
        queryObj.fq__subjects_id_l2 = encodedSubjects;
      }
    }

    const isOnlyConsortiaAccess = customerData?.product_type === "7";
    if (isOnlyConsortiaAccess) {
      queryObj.fq__acl_group = customerData.consortia_filter;
    }

    const customerId =
      profileData &&
      profileData.informaticscustomer_id &&
      profileData.informaticscustomer_id !== "undefined"
        ? profileData.informaticscustomer_id
        : "0";
    const fullTextQuery = await queryConstructor({
      ...queryObj,
      "fq__(fulltext": `true OR acl_group=(${customerId}))`,
    });

    const fullTextQueryHistory = await queryConstructor({
      ...queryObj,
      "fq__(fulltext": `true OR acl_group=(${customerId}))`,
    });

    const allQuery = await queryConstructor({ ...queryObj });

    const logSearchQuery = await queryConstructor({
      ...queryObj,
      logsearchhistory: true,
    });

    dispatch(
      updateQuery({
        fullTextQuery: fullTextQuery,
        allTextQuery: allQuery,
      }),
    );

    dispatch(updateDSPACECollection(false));
    dispatch(updataLibraryOpac(false));
    dispatch(updateIsOpac_dspace(false));

    if (selectedTags.includes(100) && selectedTags.length === 1) {
      dispatch(updataLibraryOpac(true));
      let kohaQueryObj = {};
      Object.assign(kohaQueryObj, { search_keyword: searchterm.trim() });
      Object.assign(kohaQueryObj, {
        customer_id: customerData?.informaticscustomer_id,
      });
      Object.assign(kohaQueryObj, { page_no: 1 });
      Object.assign(kohaQueryObj, { per_page: 15 });
      let kohaQuery = await queryConstructor(kohaQueryObj, "AND", true);
      const data: any = await getOpacData(kohaQuery);
      dispatch(updateSubjectFacets(data?.data.jsonfacets));
      dispatch(updateAuthorFacets(data?.data.jsonfacets));
      dispatch(updateAllFacets(data?.data.jsonfacets));
      dispatch(updateOpacResults(data?.data));
      if (data?.data?.docs) {
        navigate("/basicSearchScreen?searchterm=" + searchterm, {
          state: {
            searchTerm: searchterm,
            fullTextQuery: fullTextQuery,
            allQuery: allQuery,
          },
        });
      } else {
        notify("error", "No results found");
        setLoading(false);
      }
      return;
    }

    if (selectedTags.includes(101) && selectedTags.length === 1) {
      dispatch(updateDSPACECollection(true));
      let timeout: any;
      const timeoutPromise = new Promise<never>(
        (_, reject) =>
          (timeout = setTimeout(() => {
            notify(
              "error",
              "We are currently unable to fetch results for your input due to a temporary issue with the API service. For further assistance, please contact your librarian",
            );
            reject(new Error("Request timed out"));
          }, 30000)),
      );
      try {
        let queryObj = {};
        Object.assign(queryObj, {
          basic_search: formatString(searchterm.trim()),
        });
        Object.assign(queryObj, { page_no: 1 });
        Object.assign(queryObj, { per_page: 15 });
        let dspaceQuery = await queryConstructor(queryObj, "AND", true);
        const response = await Promise.race([
          dSpaceSearchQuery(dspaceQuery),
          timeoutPromise,
        ]);
        clearTimeout(timeout);
        dispatch(updateSubjectFacets(response?.jsonfacets));
        dispatch(updateAuthorFacets(response?.jsonfacets));
        dispatch(updateAllFacets(response?.jsonfacets));
        dispatch(updateSearchResults(response));
        if (response?.docs) {
          navigate("/basicSearchScreen?searchterm=" + searchterm, {
            state: {
              searchTerm: searchterm,
              fullTextQuery: fullTextQuery,
              allQuery: allQuery,
            },
          });
        } else {
          notify("error", "No results found");
          setLoading(false);
        }
        return;
      } catch (error) {
        console.log("error", error);
      }
    }

    if (
      selectedTags.includes(101) &&
      selectedTags.includes(100) &&
      selectedTags.length === 2
    ) {
      dispatch(updataLibraryOpac(true));
      dispatch(updateIsOpac_dspace(true));
      let kohaQueryObj = {};
      Object.assign(kohaQueryObj, { search_keyword: searchterm.trim() });
      Object.assign(kohaQueryObj, {
        customer_id: customerData?.informaticscustomer_id,
      });
      Object.assign(kohaQueryObj, { page_no: 1 });
      Object.assign(kohaQueryObj, { per_page: 15 });
      let kohaQuery = await queryConstructor(kohaQueryObj, "AND", true);
      const data: any = await getOpacData(kohaQuery);
      dispatch(updateSubjectFacets(data?.data.jsonfacets));
      dispatch(updateAuthorFacets(data?.data.jsonfacets));
      dispatch(updateAllFacets(data?.data.jsonfacets));
      dispatch(updateOpacResults(data?.data));
      if (data?.data?.docs) {
        navigate("/basicSearchScreen?searchterm=" + searchterm, {
          state: {
            searchTerm: searchterm,
            fullTextQuery: fullTextQuery,
            allQuery: allQuery,
          },
        });
      } else {
        notify("error", "No results found");
        setLoading(false);
      }
      return;
    }

    const allCountFromLog = await basicSearchQuery(logSearchQuery);
    const fullTextData = await basicSearchQuery(fullTextQueryHistory);
    dispatch(updateSearchResults(fullTextData));
    dispatch(updateFullText(true));
    setLoading(false);

    if (fullTextData?.docs) {
      navigate("/basicSearchScreen?searchterm=" + searchterm, {
        state: {
          searchTerm: searchterm,
          fullTextQuery: fullTextQuery,
          allQuery: allQuery,
          allCount: allCountFromLog?.hits,
          fullCount: fullTextData?.hits,
          from: "basic",
          fullTextData: fullTextData,
        },
      });
    }

    dispatch(updateSubjectFilterLoader(true));
    dispatch(updateAuthorFiltersLoader(true));
    dispatch(updateOtherFiltersLoader(true));

    const meshKeywordFacetData =
      await meshKeywordJsonFacetQuery(fullTextQueryHistory);
    const meshData =
      meshKeywordFacetData?.jsonfacets?.mesh_keywords?.buckets?.map(
        (item: any) => item.val,
      );
    const meshKeywordData = await fetchMeshKeywordsData(meshData);
    dispatch(updateMeshKEywordFacets(meshKeywordFacetData?.jsonfacets));
    dispatch(updateMeshKeywordFacetsList(meshKeywordData));
  }

  async function handleSemanticSearch({ searchterm }: SearchInput) {
    if (loading) return;

    if (!searchterm.trim()) {
      setError("searchterm", {
        type: "required",
        message: "Please input valid keyword / topic to search",
      });
      return;
    }
    if (!validateSearchTerm(searchterm)) {
      setError("searchterm", {
        type: "required",
        message: "Please input valid keyword / topic to search",
      });
      return;
    }

    setLoading(true);
    dispatch(clearSearchTerm());
    dispatch(clearMeshKeyword());
    dispatch(clearSubstances());
    dispatch(clearAllFiltersValue());
    dispatch(clearClassificationNum());

    const profile_id =
      profileData.user_id || sessionStorage.getItem("user_id") || null;
    const customer_id =
      profileData1?.informaticscustomer_id ||
      sessionStorage.getItem("informaticscustomer_id") ||
      null;

    try {
      // â”€â”€ Step 1: get AI-formed query â”€â”€
      const formData = new FormData();
      formData.append("profile_id", String(profile_id ?? ""));
      formData.append("user_query", searchterm.trim());
      formData.append("customer_id", String(customer_id ?? ""));

      const aiResponse = await fetch(
        `${api.baseApi}/api/ai_search_query_formation/`,
        {
          method: "POST",
          body: formData,
        },
      );
      const aiData = await aiResponse.json();
      const rawData = aiData?.data ?? aiData;

      if (!rawData?.search_query) {
        notify("error", "Unable to form a search query. Please try again.");
        setLoading(false);
        return;
      }

      const cleanField = (val: string): string =>
        val.replace(/\\"/g, '"').replace(/^"|"$/g, "").trim();

      const aiQuery = cleanField(rawData.search_query);
      const userQuery = searchterm.trim(); // natural-language query â†’ breadcrumbs

      setAiUserQuery(userQuery);

      // â”€â”€ Step 2: dispatch Redux state (mirrors handleSearch, sort = Best Match) â”€â”€
      // user_query drives the breadcrumb chip; search_query drives the Solr call
      dispatch(updateAllFilter({ key: "search-term", value: userQuery }));
      dispatch(updateSearchTerm(aiQuery));
      dispatch(updateSubjectType(selectedSubjects));
      dispatch(updateSubjectName(selectedSubjectNames));
      dispatch(updateRow(15));
      dispatch(updatePage(1));
      dispatch(updateSort("score desc")); // Best Match for semantic
      dispatch(updateQueries({ key: "searchTerm", value: aiQuery }));
      dispatch(updateSubjectFacets([]));
      dispatch(updateAuthorFacets([]));
      dispatch(updateAllFacets([]));

      // Dispatch non-null AI filter fields into Redux (filter UI)
      if (rawData?.fq__authors_tk)
        dispatch(updateAuthor(cleanField(rawData.fq__authors_tk)));
      if (rawData?.fq__author_address)
        dispatch(updateInstitution(cleanField(rawData.fq__author_address)));
      if (rawData?.fq__author_country_name)
        dispatch(
          updateCountryOfPublishingAuthor(
            cleanField(rawData.fq__author_country_name),
          ),
        );
      if (rawData?.fq__journal_name)
        dispatch(updateJournal(cleanField(rawData.fq__journal_name)));
      if (rawData?.fq__publisher_name)
        dispatch(updatePublisher(cleanField(rawData.fq__publisher_name)));
      if (rawData?.fq__yearfrom) dispatch(updateYearFrom(rawData.fq__yearfrom));

      // â”€â”€ Step 3: build query objects (mirrors handleSearch) â”€â”€
      let encodedSubjects = "";
      if (selectedSubjects.length === 0) {
        encodedSubjects = `(${temporaryQueryConstructor(subjectData?.map((x) => x.datsubjectmasterlevel2_id))})`;
      } else {
        encodedSubjects = `(${temporaryQueryConstructor(selectedSubjects)})`;
      }

      let tags = [...selectedTags];
      if (tags.includes(1) && !tags.includes(2)) tags.push(2);
      if (tags.includes(1) && !tags.includes(5)) tags.push(5);
      if (tags.includes(1) && !tags.includes(24)) tags.push(24);
      if (!tags.includes(1) && tags.includes(2))
        tags = tags.filter((t) => t !== 2);
      if (!tags.includes(1) && tags.includes(5))
        tags = tags.filter((t) => t !== 5);
      if (!tags.includes(1) && tags.includes(24))
        tags = tags.filter((t) => t !== 24);
      dispatch(updateDataType(tags));

      let encodedTags = "";
      if (tags.length === 0) {
        encodedTags = "( 1 OR 4 OR 2 OR 3 OR 8 OR 24 )";
      } else if (
        tags.length === 2 &&
        tags.includes(100) &&
        tags.includes(101)
      ) {
        encodedTags = "(100 OR 101)";
      } else if (tags.length === 1 && (tags[0] === 100 || tags[0] === 101)) {
        encodedTags = `(${tags[0]})`;
      } else {
        encodedTags = `(${temporaryQueryConstructor(tags)})`;
      }

      const queryObj: any = {
        titleKeywordsAbs: aiQuery,
        sort: "score desc",
        fq__resource_type: encodedTags,
        rows: 15,
        op_mode: "and",
        sessionid: sessionStorage.getItem("session_key"),
        profileuserid: sessionStorage.getItem("user_id"),
        datsearchtype_id: "9",
        customerid: sessionStorage.getItem("informaticscustomer_id"),
      };

      // Append non-null AI filter fields to the Solr query
      if (rawData?.fq__authors_tk)
        queryObj.fq__authors_tk = cleanField(rawData.fq__authors_tk);
      if (rawData?.fq__journal_name)
        queryObj.fq__journal_name = cleanField(rawData.fq__journal_name);
      if (rawData?.fq__publisher_name)
        queryObj.fq__publisher_name = cleanField(rawData.fq__publisher_name);
      if (rawData?.fq__yearfrom) queryObj.fq__yearfrom = rawData.fq__yearfrom;
      if (rawData?.fq__author_address)
        queryObj.fq__author_address = cleanField(rawData.fq__author_address);
      if (rawData?.fq__author_country_name)
        queryObj.fq__author_country_name = cleanField(
          rawData.fq__author_country_name,
        );

      if (
        encodedSubjects &&
        selectedSubjects.length &&
        !selectedSubjects.includes(0)
      ) {
        if (
          enable_onos &&
          selectedSubjects.length === defaultSubjectIds.length
        ) {
          Object.assign(queryObj, {
            "fq__(subjects_id_l2": `${encodedSubjects} OR is_onos_resource=true)`,
          });
        } else {
          queryObj.fq__subjects_id_l2 = encodedSubjects;
        }
      }

      if (customerData?.product_type === "7")
        queryObj.fq__acl_group = customerData.consortia_filter;

      const customerId =
        profileData?.informaticscustomer_id &&
        profileData.informaticscustomer_id !== "undefined"
          ? profileData.informaticscustomer_id
          : "0";

      const fullTextQuery = await queryConstructor({
        ...queryObj,
        "fq__(fulltext": `true OR acl_group=(${customerId}))`,
      });
      const fullTextQueryHistory = await queryConstructor({
        ...queryObj,
        "fq__(fulltext": `true OR acl_group=(${customerId}))`,
      });
      const allQuery = await queryConstructor({ ...queryObj });
      const logSearchQuery = await queryConstructor({
        ...queryObj,
        logsearchhistory: true,
      });

      dispatch(updateQuery({ fullTextQuery, allTextQuery: allQuery }));
      dispatch(updateDSPACECollection(false));
      dispatch(updataLibraryOpac(false));
      dispatch(updateIsOpac_dspace(false));

      // â”€â”€ Step 4: execute search and navigate (mirrors handleSearch) â”€â”€
      const allCountFromLog = await basicSearchQuery(logSearchQuery);
      const fullTextData = await basicSearchQuery(fullTextQueryHistory);
      dispatch(updateSearchResults(fullTextData));
      dispatch(updateFullText(true));
      setLoading(false);

      // â”€â”€ Mark AI mode in Redux (centralised AI state) â”€â”€
      dispatch(
        enterAIMode({
          userQuery,
          aiQuery,
          initialAllCount: allCountFromLog?.hits ?? 0,
          initialFullCount: fullTextData?.hits ?? 0,
        }),
      );

      if (fullTextData?.docs) {
        navigate(
          "/basicSearchScreen?searchterm=" + encodeURIComponent(userQuery),
          {
            state: {
              searchTerm: aiQuery, // AI boolean query â†’ used for Solr
              userQuery, // natural-language query â†’ used for breadcrumbs
              fullTextQuery,
              allQuery,
              allCount: allCountFromLog?.hits,
              fullCount: fullTextData?.hits,
              from: "basic",
              fullTextData,
              searchMode: "semantic",
            },
          },
        );
      } else {
        notify("error", "No results found");
      }

      dispatch(updateSubjectFilterLoader(true));
      dispatch(updateAuthorFiltersLoader(true));
      dispatch(updateOtherFiltersLoader(true));

      // const meshKeywordFacetData = await meshKeywordJsonFacetQuery(fullTextQueryHistory);
      // const meshData = meshKeywordFacetData?.jsonfacets?.mesh_keywords?.buckets?.map((item: any) => item.val);
      // const meshKeywordData = await fetchMeshKeywordsData(meshData);
      // dispatch(updateMeshKEywordFacets(meshKeywordFacetData?.jsonfacets));
      // dispatch(updateMeshKeywordFacetsList(meshKeywordData));
    } catch (error) {
      console.log("AI search error:", error);
      notify("error", "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const handleAutoCompleteSelect = (
    term: string,
    reason: "createOption" | "selectOption" | "removeOption",
  ) => {
    const searchTerm = `"${term}"`;
    if (reason === "createOption") {
      setValue("searchterm", term);
    } else {
      setValue("searchterm", searchTerm);
    }
    setShowAutoComplete(false);
  };

  const handlePreference = (event: React.ChangeEvent<HTMLInputElement>) => {
    logSearchUsageData(112);
    if (isProfileUser) {
      let isMyPrefAdded: boolean = true;
      if (myPreference) {
        isMyPrefAdded = isPreferenceAdded(myPreference);
      }
      if (!isMyPrefAdded && event.target.checked) {
        dispatch(
          setModal({
            modalType: "PREFERENCE",
            modalProps: {
              open: true,
              checkPreferenceAdded,
            },
          }),
        );
      }
      if (!event.target.checked) {
        dispatch(clearDataTypeFilters());
        let allDocIds: any = customerData?.datatypes
          .filter((x) => x.dat_resourcetype_id !== 2)
          ?.map((obj) => obj?.dat_resourcetype_id);
        setSelectedTags(() => [...allDocIds, 0]);
      }
      setIsPreference(event.target.checked);
      sessionStorage.setItem("preference", event.target.checked.toString());
    } else {
      showIsProfileToast("Please login as profile user to use the preferences");
    }
  };

  async function checkPreferenceAdded(myPreference: GetMyPreferenceData) {
    if (!myPreference) return;
    const filteredSelectedTags = myPreference?.DataTypes.filter(
      ({ is_favorite }: any) => is_favorite,
    ).map(({ datatype_id }) => datatype_id);
    if (filteredSelectedTags?.filter((ele: any) => ele !== 2)?.length === 0) {
      setIsPreference(false);
      sessionStorage.setItem("preference", "false");
    }
  }

  function selectAllSubject() {
    if (!customerData) return;
    let filteredSubjectData: GetCustomerByIDSubject[] = [];
    let filteredSubjectIds: number[] = [];
    let filteredL1SubjectIds: number[] = [];
    let filteredSubjectNames: string[] = [];

    if (isPreference && myPreference) {
      filteredSubjectData =
        myPreference.Subjects?.map(({ subject_id1, subject2_details }) =>
          subject2_details
            .filter(({ is_favorite }) => is_favorite)
            .map((l2) => ({
              datsubjectmasterlevel1_id: subject_id1,
              datsubjectmasterlevel2_id: l2.subject_id2,
              level2subject_name: l2.subject_name2,
            })),
        ).flat() || [];

      if (filteredSubjectData.length === selectedSubjects.length) {
        filteredSubjectIds = [];
        filteredSubjectNames = [];
        filteredL1SubjectIds = [];
      } else {
        filteredSubjectIds = filteredSubjectData.map(
          ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
        );
        filteredSubjectNames = filteredSubjectData.map(
          ({ level2subject_name }) => level2subject_name,
        );
        filteredL1SubjectIds = filteredSubjectData.map(
          ({ datsubjectmasterlevel1_id }) => datsubjectmasterlevel1_id,
        );
      }
    } else {
      filteredSubjectData = customerData.subject;
      if (customerData.subject.length === selectedSubjects.length) {
        filteredSubjectIds = [];
        filteredSubjectNames = [];
        filteredL1SubjectIds = [];
      } else {
        filteredSubjectIds = customerData.subject.map(
          ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
        );
        filteredSubjectNames = customerData.subject.map(
          ({ level2subject_name }) => level2subject_name,
        );
        filteredL1SubjectIds = customerData.subject.map(
          ({ datsubjectmasterlevel1_id }) => datsubjectmasterlevel1_id,
        );
      }
    }

    setSubjectData(filteredSubjectData);
    dispatch(updateSubjectType(filteredSubjectIds));
    dispatch(updateSubjectL1Type(filteredL1SubjectIds));
    setSelectedSubjects(filteredSubjectIds);
    dispatch(updateSubjectName(filteredSubjectNames));
    setSelectedSubjectNames(filteredSubjectNames);
    logSearchUsageData(9);
  }

  function updateAllSubject() {
    let preferenceSubject =
      myPreference &&
      myPreference?.Subjects?.map(({ subject2_details }) =>
        subject2_details.filter(({ is_favorite }) => is_favorite),
      )
        .flat()
        ?.map((l2) => ({
          datsubjectmasterlevel1_id: -1,
          datsubjectmasterlevel2_id: l2.subject_id2,
          level2subject_name: l2.subject_name2,
        }));

    let isAllSelected = isPreference
      ? preferenceSubject?.length === selectedSubjects.length
      : customerData?.subject?.length === selectedSubjects.length;

    updateSubjectSelected(isAllSelected);
  }

  async function checkArticleExistance(dataArray: any) {
    if (!Array.isArray(dataArray)) return;
    const articleData = new FormData();
    const articleIds =
      Array.isArray(dataArray) && dataArray?.map((x: any) => x?.article_id);
    articleData.append("profile_id", selector.user_id);
    articleData.append("article_ids", articleIds.toString());
    const checkArticleExistanceResult =
      await checkMultipleArticleExistence(articleData);
    const filter_is_saved =
      Array.isArray(checkArticleExistanceResult) &&
      checkArticleExistanceResult.filter(
        (x: SaverArticlesType) => x.is_saved !== false,
      );
    dispatch(updateSavedArticles(filter_is_saved));
  }

  async function linkToDisplay(dataArray: any) {
    if (!Array.isArray(dataArray)) return;
    let formData = new FormData();
    let data = dataArray?.map((obj: any) => {
      let object: any = {
        customer_id: customerData?.informaticscustomer_id,
        article_id: obj?.article_id,
        consortia_virtualid: customerData?.consortia_virtualid,
        resource_type: obj?.resource_type,
        access_type: obj?.article_open_status || obj?.access_type_id || null,
        is_oa_article: obj?.fulltext || false,
      };
      if (obj?.articledoi) object.article_doi = obj?.articledoi;
      if (obj?.resourceissue_id)
        object.resourceissue_id = obj?.resourceissue_id;
      if (obj?.is_onos_resource) object.is_onos_resource = true;
      return object;
    });
    let formApiData = { data };
    formData.append("detailed_json", JSON.stringify(formApiData));
    const response = await getBulkLinkRecords(formData);
    if (response?.message === "Ok") {
      dispatch(updateLinkToDisplay(response?.data));
    }
  }

  async function findAlertTypeSetting(dataArray: any) {
    try {
      const resourcemasterData =
        Array.isArray(dataArray) &&
        dataArray?.filter((x: any) => x?.resourcemaster_id !== undefined);
      const resourcemaster_ids =
        Array.isArray(resourcemasterData) &&
        resourcemasterData
          ?.map((x: any) => x?.resourcemaster_id)
          ?.filter((y: any) => y !== undefined);
      if (Array.isArray(resourcemaster_ids)) {
        const alertSettingData = await getAlertSettings(
          selector.user_id,
          resourcemaster_ids,
        );
        let alertDataRes = alertSettingData.data.data[0][0];
        dispatch(updateAlertSettingData(alertDataRes));
      }
    } catch (err) {
      console.log(err);
    }
  }

  function openPreferenceInfoModal() {
    dispatch(
      setModal({
        modalType: "PREFERENCE_INFO_MODEL",
        modalProps: {
          isOpen: true,
          from: "basicsearch",
        },
      }),
    );
  }

  function handleCloseModal() {
    setModalIsOpen(false);
  }

  const handleDisable = () => {
    return (
      (selectedTags.includes(100) && selectedTags.length === 1) ||
      (selectedTags.includes(101) && selectedTags.length === 1) ||
      (selectedTags.includes(100) &&
        selectedTags.includes(101) &&
        selectedTags.length === 2)
    );
  };

  const handleRemove = (tagsArray: any[]) => {
    setSelectedTags([]);
  };

  const handleNotificationLink = () => {
    const notificationURL = notifications?.[0]?.url;
    window.open(notificationURL, "_blank");
  };

  let navItems = [
    {
      label: "Search Builder",
      path: "/search-builder",
      icon: (
        <img
          src={SearchCircle}
          alt="Advanced Search"
          style={{ padding: "2px" }}
        />
      ),
    },
    {
      label: "Author Finder",
      path: "/authorfinder",
      icon: <AccountCircleOutlinedIcon />,
    },
    {
      label: "Journal Finder",
      path: "/BrowseJournalTableSearch",
      icon: <PlagiarismOutlinedIcon />,
    },
  ];

  if (bookUser?.includes(12)) {
    navItems.push({
      label: "Book Finder",
      path: "/BookSearch",
      icon: (
        <img
          src={bookImage}
          alt="Book Finder"
          style={{ padding: "2px", width: "25px", height: "23px" }}
        />
      ),
    });
  }
  if (bookUser?.includes(27)) {
    navItems.push({
      label: "Virtual Tumour Board Videos",
      path: "/ncgFinder",
      icon: <PlayCircleOutlineIcon />,
    });
  }

  const navLinkClick = (urldata: any) => {
    dispatch(clearMeshKeyword());
    dispatch(clearSubstances());
    dispatch(clearClassificationNum());
    if (urldata === "/search-builder") {
      navigate("/search-builder");
      logSearchUsageData(12);
    }
    if (urldata === "/authorfinder") {
      navigate("/authorfinder");
      logSearchUsageData(15);
    }
    if (urldata === "/BrowseJournalTableSearch") {
      navigate("/BrowseJournalTableSearch");
      logSearchUsageData(76);
      dispatch(updateBrowserRow(15));
      dispatch(updateBrowserPage(1));
    }
    if (urldata === "/BookSearch") {
      navigate("/BookSearch");
      logSearchUsageData(122);
      dispatch(updateBookPublisherCollection("J-GateCollection"));
      dispatch(updateBrowserPage(1));
      dispatch(updateBrowserRow(15));
    }
    if (urldata === "/ncgFinder") {
      navigate("/ncgFinder");
    }
  };

  return (
    <Box className="search-container">
      <HeaderSection
        handleWelcomeClick1={handleNotificationLink}
        handleCloseModal={handleCloseModal}
        modalIsOpen={modalIsOpen}
        animationGreeting={scrollRightToLeft}
        notifications={notifications}
      />

      <Box className="flex-grow-container search-field">
        <Box sx={{ display: "flex" }}>
          {customerData?.consortiamaster_id === 1874 ? (
            <Stack direction={"row"} spacing={5}>
              <Stack
                direction={"row"}
                spacing={1}
                marginTop={0}
                flexWrap="wrap"
              >
                <Text
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: "12px", sm: "16px" },
                  }}
                >
                  <Link
                    target="_blank"
                    href=" https://www.indiastatagri.com/"
                    style={{ cursor: "pointer", color: "green" }}
                    underline="none"
                  >
                    India Agristat
                  </Link>
                </Text>
              </Stack>
              <Stack
                direction={"row"}
                spacing={1}
                marginTop={0}
                flexWrap="wrap"
              >
                <Text
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: "12px", sm: "16px" },
                    wordBreak: "break-word",
                  }}
                >
                  <Link
                    target="_blank"
                    href="https://jgatenext.com/cdn/cerabooks.html"
                    style={{ cursor: "pointer", color: "green" }}
                    underline="none"
                  >
                    CeRA Subscribed Elsevier e-books
                  </Link>
                </Text>
              </Stack>
            </Stack>
          ) : null}
        </Box>

        <Stack
          direction={"row"}
          spacing={{ xs: 1, sm: 2, md: 10 }}
          alignItems="center"
          paddingTop={{ xs: "1rem" }}
        >
          <Text variant="h5" fontFamily={"Helvetica Neue"} fontWeight={"600"}>
            Search
          </Text>
          <Stack direction={"row"} spacing={1} alignItems="center">
            <FormControlLabel
              control={
                <Switch
                  sx={{ m: 1 }}
                  checked={isPreference}
                  onChange={handlePreference}
                  inputProps={{ "aria-label": "Preferences Switch" }}
                  disabled={isAICustomer && isSemanticMode}
                />
              }
              label="Preferences"
              labelPlacement="start"
              sx={{ opacity: isAICustomer && isSemanticMode ? 0.5 : 1 }}
            />
            <Stack>
              <IconButton
                size="medium"
                onClick={openPreferenceInfoModal}
                disabled={isAICustomer && isSemanticMode}
                sx={{ opacity: isAICustomer && isSemanticMode ? 0.5 : 1 }}
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Stack>
          </Stack>

          <Stack
            direction={"row"}
            spacing={1}
            marginTop={0}
            flexWrap="wrap"
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "flex",
                xl: "flex",
              },
            }}
          >
            {navItems?.map((item, i) => (
              <Stack key={i} direction={"row"} alignItems="center">
                {item.icon}
                <ListItem
                  onClick={() => {
                    dispatch(updateIsNavigatingBack(false));
                    navLinkClick(item.path);
                    sessionStorage.setItem("getTabSwitch", "0");
                    dispatch(updateBookCollection(""));
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  {item.label}
                </ListItem>
              </Stack>
            ))}
          </Stack>
        </Stack>

        {/* Doc type chips */}
        <Stack
          direction={"row"}
          spacing={1.2}
          marginTop={2}
          flexWrap="wrap"
          sx={{
            opacity: isAICustomer && isSemanticMode ? 0.4 : 1,
            pointerEvents: isAICustomer && isSemanticMode ? "none" : "auto",
            transition: "opacity 0.2s ease",
          }}
        >
          {sortTags(allTags)
            ?.slice(0, activeScreenWidth)
            ?.map((data) => (
              <Chip
                key={data.dat_resourcetype_id}
                label={
                  data.accesstype === dataTypes.journals
                    ? dataTypes.journalArticle
                    : data?.accesstype
                }
                color="primary"
                variant={"outlined"}
                onClick={() => handleTags(data.dat_resourcetype_id)}
                sx={{
                  p: "4px",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: (
                    data.dat_resourcetype_id === 0
                      ? selectedTags.includes(0)
                      : selectedTags.includes(data.dat_resourcetype_id) &&
                        !selectedTags.includes(0)
                  )
                    ? "primary.main"
                    : "#DCD2EF",
                  background: (
                    data.dat_resourcetype_id === 0
                      ? selectedTags.includes(0)
                      : selectedTags.includes(data.dat_resourcetype_id) &&
                        !selectedTags.includes(0)
                  )
                    ? "#DCD2EF"
                    : "#FFF",
                  color: (
                    data.dat_resourcetype_id === 0
                      ? selectedTags.includes(0)
                      : selectedTags.includes(data.dat_resourcetype_id) &&
                        !selectedTags.includes(0)
                  )
                    ? "primary.main"
                    : "#71717A",
                  textTransform: "capitalize",
                  "&:hover": { background: "#DCD2EF" },
                }}
              />
            ))}
          {sortTags(allTags)?.slice(activeScreenWidth).length > 0 && (
            <Select
              displayEmpty
              renderValue={() =>
                is_xs || isxs ? "Select document types" : "Other document types"
              }
              open={dropdown}
              onClose={() => setDropDown(false)}
              onOpen={() => setDropDown(true)}
              sx={{
                border: "1px solid",
                borderColor:
                  !selectedTags.includes(0) &&
                  selectedTags?.some((tag) =>
                    sortTags(allTags)
                      ?.slice(activeScreenWidth)
                      ?.map((item) => item?.dat_resourcetype_id)
                      ?.includes(tag),
                  )
                    ? "primary.main"
                    : "#DCD2EF",
                borderRadius: "6px",
                background:
                  !selectedTags.includes(0) &&
                  selectedTags?.some((tag) =>
                    sortTags(allTags)
                      ?.slice(activeScreenWidth)
                      ?.map((item) => item?.dat_resourcetype_id)
                      ?.includes(tag),
                  )
                    ? "#DCD2EF"
                    : "#FFF",
                color:
                  !selectedTags.includes(0) &&
                  selectedTags?.some((tag) =>
                    sortTags(allTags)
                      ?.slice(activeScreenWidth)
                      ?.map((item) => item?.dat_resourcetype_id)
                      ?.includes(tag),
                  )
                    ? "primary.main"
                    : "#71717A",
                "& .MuiSelect-select": {
                  padding: "1px 1px 1px 12px",
                  display: "flex",
                  alignItems: "center",
                  textTransform: "capitalize",
                  border: "none",
                  fontSize: "12px",
                  height: "28px",
                },
              }}
            >
              <Box>
                <Box
                  className="dropdown-container"
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "1fr",
                      sm: "1fr 1fr",
                      md: "1fr 1fr 1fr",
                      lg: "1fr 1fr",
                    },
                    gap: "1px",
                  }}
                >
                  {allTags?.slice(activeScreenWidth)?.map((data) => (
                    <Box
                      key={data.dat_resourcetype_id}
                      sx={{
                        margin: "0px 5px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        checked={
                          selectedTags.includes(data.dat_resourcetype_id) &&
                          !selectedTags.includes(0)
                        }
                        onClick={() => handleTags(data.dat_resourcetype_id)}
                      />
                      <Typography sx={{ fontSize: "13px", fontWeight: "400" }}>
                        {data.accesstype === dataTypes.journals
                          ? dataTypes.journalArticle
                          : data?.accesstype}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 3,
                    padding: "0px 0px 12px 12px",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => setDropDown(false)}
                  >
                    Apply
                  </Button>
                  <Button
                    variant="text"
                    onClick={() => {
                      handleRemove(allTags?.slice(4));
                      setDropDown(false);
                    }}
                  >
                    Clear All
                  </Button>
                </Box>
              </Box>
            </Select>
          )}
        </Stack>

        {/* Search input: AI card for customer 18, traditional row for all others */}
        {isAICustomer ? (
          <Box
            sx={{
              width: "100%",
              backgroundColor: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
              overflow: "visible",
              textAlign: "left",
              mt: 2,
              mb: 3,
            }}
          >
            <Box
              sx={{
                px: { xs: 2, md: 3 },
                pt: { xs: 2, md: 2.5 },
                pb: 1,
                minHeight: { xs: "90px", md: "15vh" },
                position: "relative",
              }}
            >
              <AutoCompleteField
                fieldName="searchterm"
                options={isSemanticMode ? [] : autoCompleteData || []}
                control={control}
                handleSubmit={handleSubmit}
                handleSearch={handleSearch}
                handleAutoCompleteSelect={handleAutoCompleteSelect}
                setValue={setValue}
                loading={loading}
                navigate={navigate}
                selectedTags={selectedTags}
                selectedSubjects={selectedSubjects}
                selectedSubjectNames={selectedSubjectNames}
                subjectData={subjectData}
                wrongWord={isSemanticMode ? null : wrongWord}
                suggestionsData={isSemanticMode ? null : suggestionsData}
                dropdownPlacement="bottom"
                fullWidth
                from="airsearch"
                maxLength={isSemanticMode ? 150 : undefined}
              />
            </Box>
            <Divider />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1,
                px: { xs: 1.5, md: 2.5 },
                py: { xs: 1.2, md: 1.5 },
              }}
            >
              <Select
                multiple
                displayEmpty
                renderValue={() => {
                  if (isAllSubjectSelected) return "All Subjects";
                  if (selectedSubjectNames.length === 0) return "Subject";
                  if (selectedSubjectNames.length === 1)
                    return selectedSubjectNames[0];
                  return `${selectedSubjectNames.length} Subjects`;
                }}
                value={selectedSubjectNames}
                disabled={isSemanticMode || handleDisable()}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: `${themeContext.windowHeight * 0.6}px`,
                    },
                  },
                  anchorOrigin: { vertical: "top", horizontal: "center" },
                  transformOrigin: {
                    vertical: "bottom",
                    horizontal: "center",
                  },
                }}
                sx={{
                  height: "36px",
                  minWidth: { xs: 110, sm: 140 },
                  maxWidth: { xs: 150, sm: 180 },
                  backgroundColor: "#f9fafb",
                  borderRadius: "8px",
                  opacity: isSemanticMode ? 0.5 : 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e5e7eb",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#7852fb",
                  },
                  "& .MuiSelect-select": {
                    py: "6px",
                    px: "10px",
                    fontSize: "13px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <MenuItem onClick={selectAllSubject}>
                  <Checkbox checked={isAllSubjectSelected} size="small" />
                  <Text sx={{ fontSize: "13px" }}>All</Text>
                </MenuItem>
                {Array.isArray(subjectData) &&
                  subjectData?.map((data) => (
                    <MenuItem
                      key={data.datsubjectmasterlevel2_id}
                      value={data.datsubjectmasterlevel2_id}
                      onClick={() => handleSubjectDropdown(data)}
                    >
                      <Checkbox
                        checked={selectedSubjects.includes(
                          data.datsubjectmasterlevel2_id,
                        )}
                        size="small"
                      />
                      <Text
                        sx={{
                          fontSize: "13px",
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {data.level2subject_name}
                      </Text>
                    </MenuItem>
                  ))}
              </Select>

              <Stack
                direction="row"
                alignItems="center"
                flexWrap="wrap"
                sx={{ gap: { xs: 0.8, sm: 1 } }}
              >
                <Select
                  value={searchMode}
                  onChange={(e) => setSearchMode(e.target.value as SearchMode)}
                  sx={{
                    height: "36px",
                    minWidth: { xs: 110, sm: 130 },
                    backgroundColor: "#f9fafb",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#e5e7eb",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7852fb",
                    },
                    "& .MuiSelect-select": {
                      py: "6px",
                      px: "10px",
                      fontSize: "13px",
                    },
                  }}
                >
                  <MenuItem value="boolean">
                    <Box>
                      <Typography
                        fontWeight={600}
                        fontSize="13px"
                        lineHeight={1.3}
                      >
                        Boolean
                      </Typography>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block"
                        lineHeight={1.4}
                      >
                        Keyword search with operators
                      </Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value="semantic">
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <Typography
                          fontWeight={600}
                          fontSize="13px"
                          lineHeight={1.3}
                        >
                          AI-Model
                        </Typography>
                        <Chip
                          label="beta"
                          size="small"
                          sx={{
                            height: "16px",
                            fontSize: "9px",
                            backgroundColor: "#e8e0fa",
                            color: "#7852fb",
                            fontWeight: 600,
                          }}
                        />
                      </Box>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block"
                        lineHeight={1.4}
                      >
                        AI-powered meaning search
                      </Typography>
                    </Box>
                  </MenuItem>
                </Select>

                <Button
                  onClick={handleSubmit(
                    isSemanticMode ? handleSemanticSearch : handleSearch,
                  )}
                  variant="contained"
                  disabled={loading}
                  sx={{
                    height: "36px",
                    px: { xs: 2, sm: 3 },
                    borderRadius: "8px",
                    textTransform: "none",
                    fontSize: { xs: "13px", sm: "14px" },
                    fontWeight: 600,
                    minWidth: {
                      xs: "auto",
                      sm: isSemanticMode ? "158px" : "90px",
                    },
                    whiteSpace: "nowrap",
                    transition: "min-width 0.2s ease",
                  }}
                >
                  {loading ? (
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                  ) : isSemanticMode ? (
                    "Analyze & Explore"
                  ) : (
                    "Search"
                  )}
                </Button>
              </Stack>
            </Box>
          </Box>
        ) : (
          /* Traditional layout for all other customers */
          <Stack
            direction={"row"}
            marginTop={2}
            alignItems="flex-end"
            mb={3}
            sx={{
              flexDirection: { xs: "column", sm: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "start" },
              gap: 2,
            }}
          >
            <Box
              width={300}
              sx={{
                width: { xs: "100%", sm: "80%", md: "50%", lg: "550px" },
              }}
            >
              <Text fontWeight="500" fontFamily={"Helvetica Neue"}>
                Subject
              </Text>
              <Select
                fullWidth
                multiple
                renderValue={(selected) => selected && selected.join(", ")}
                value={isAllSubjectSelected ? ["All"] : selectedSubjectNames}
                sx={{
                  backgroundColor: "#fff",
                  width: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                    lg: "350px",
                  },
                  minWidth: 100,
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: `${themeContext.windowHeight * 0.7}px`,
                    },
                  },
                  anchorOrigin: {
                    vertical: "center",
                    horizontal: "center",
                  },
                  transformOrigin: {
                    vertical: "center",
                    horizontal: "center",
                  },
                }}
                disabled={handleDisable()}
              >
                <MenuItem onClick={selectAllSubject}>
                  <Checkbox checked={isAllSubjectSelected} />
                  <Text>All</Text>
                </MenuItem>
                {Array.isArray(subjectData) &&
                  subjectData?.map((data) => (
                    <MenuItem
                      key={data.datsubjectmasterlevel2_id}
                      value={data.datsubjectmasterlevel2_id}
                      onClick={() => handleSubjectDropdown(data)}
                    >
                      <Checkbox
                        checked={selectedSubjects.includes(
                          data.datsubjectmasterlevel2_id,
                        )}
                      />
                      <Text
                        sx={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          overflowWrap: "break-word",
                        }}
                      >
                        {data.level2subject_name}
                      </Text>
                    </MenuItem>
                  ))}
              </Select>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
                mx: "auto",
                alignContent: "center",
                marginTop: { md: "25px" },
              }}
            >
              <AutoCompleteField
                fieldName="searchterm"
                options={autoCompleteData || []}
                control={control}
                handleSubmit={handleSubmit}
                handleSearch={handleSearch}
                handleAutoCompleteSelect={handleAutoCompleteSelect}
                setValue={setValue}
                loading={loading}
                navigate={navigate}
                selectedTags={selectedTags}
                selectedSubjects={selectedSubjects}
                selectedSubjectNames={selectedSubjectNames}
                subjectData={subjectData}
                wrongWord={wrongWord}
                suggestionsData={suggestionsData}
                dropdownPlacement="top"
              />
            </Box>
            <Box
              sx={{
                width: { xs: "100%", sm: "80%", md: "80%" },
                marginTop: { md: "25px" },
              }}
            >
              <Button
                onClick={handleSubmit(handleSearch)}
                variant="contained"
                className="basic-button"
              >
                {loading ? (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "#fff",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                ) : (
                  "Search"
                )}
              </Button>
            </Box>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default AISearch;
